var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#4E94FF",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2,
    d: "m12.916 16.227.826-10.962a.355.355 0 0 0-.378-.263.35.35 0 0 0-.316.334l-.1-.005-.381 7.573-.486-1.812v-.003a.459.459 0 0 0-.44-.326h-.793l-.587-2.158a.456.456 0 0 0-.44-.338h-.004a.456.456 0 0 0-.427.36l-.701 3.22-.663-1.757a.452.452 0 0 0-.428-.294H2.852a.453.453 0 0 0 0 .903h4.44l1.091 2.896c.07.194.262.305.452.294h.005a.465.465 0 0 0 .412-.36l.625-2.903.191.703v.002a.456.456 0 0 0 .43.335h.803l1.14 4.23a.44.44 0 0 0 .431.33h.044Zm.923-10.987-.615 10.553.1.005.389-7.564.864 3.243.001.003a.459.459 0 0 0 .439.326h2.136a.453.453 0 0 0 0-.902h-1.796L13.84 5.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.2,
    d: "m12.916 16.227.826-10.962a.355.355 0 0 0-.378-.263.35.35 0 0 0-.316.334l-.1-.005-.381 7.573-.486-1.812v-.003a.459.459 0 0 0-.44-.326h-.793l-.587-2.158a.456.456 0 0 0-.44-.338h-.004a.456.456 0 0 0-.427.36l-.701 3.22-.663-1.757a.452.452 0 0 0-.428-.294H2.852a.453.453 0 0 0 0 .903h4.44l1.091 2.896c.07.194.262.305.452.294h.005a.465.465 0 0 0 .412-.36l.625-2.903.191.703v.002a.456.456 0 0 0 .43.335h.803l1.14 4.23a.44.44 0 0 0 .431.33h.044Zm.923-10.987-.615 10.553.1.005.389-7.564.864 3.243.001.003a.459.459 0 0 0 .439.326h2.136a.453.453 0 0 0 0-.902h-1.796L13.84 5.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusPage);
export default __webpack_public_path__ + "static/media/status-page.ac3822def6f85277d68ba951a7d04852.svg";
export { ForwardRef as ReactComponent };